import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImoveisLocalizacaoPage } from './imoveis-localizacao.page';

const routes: Routes = [{ path: '', component: ImoveisLocalizacaoPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImoveisLocalizacaoRoutingModule { }
